// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swap-btn-grp {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.swap-left-guid {
  width: 600px;
}

.swap-title {
  font-size: 50px;
  font-weight: 700;
  color: #000;
  letter-spacing: 3px;
}

.swap_main {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
}

.swap-para-text {
  color: #515151;
  font-size: 17px;
  font-weight: 400;
}

.swap-exchng-comp {
  width: 650px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  height: -moz-fit-content;
  height: fit-content;
  padding: 1.5rem;
}

.forge-cards-main {
  display: flex;
  justify-content: space-around;
  /* align-items: center; */
  flex-wrap: wrap;
  row-gap: 3rem;
  column-gap: 5rem;
  margin-left: 20px;
}

.forge_card {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.crd-cnt {
  width: 120px;
  height: 120px;
  background-color: #0e4e8d;
  color: #fff;
  font-size: 42px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 26px;
  left: -45px;
  /* margin: 0 auto; */
}

.crd-nums {
  color: #fff;
  font-size: 45px;
  font-weight: 600;
  /* position: absolute; */
  left: 65px;
  top: 48px;
  z-index: 2;
}

.cdt-cnt1 {
  background-color: #0e4e8d;
}
.cdt-cnt2 {
  background-color: #3fbe7f;
}
.cdt-cnt3 {
  background-color: #da5f9d;
}
.cdt-cnt4 {
  background-color: #f69737;
}
.cdt-cnt5 {
  background-color: #9f72cc;
}

.frg_crd_cnt {
  /* position: relative; */
  left: 3rem;
  width: 495px;
  height: 210px;
  padding: 10px 12px;
  border-radius: 10px;
}

.frg-crd-indx-clrs1 {
  border: 2px solid #0e4e8d;
  background: linear-gradient(
    90deg,
    rgba(228, 241, 255, 0.5) 0%,
    rgba(228, 241, 255, 0) 50.75%,
    rgba(228, 241, 255, 0.5) 101.5%
  );
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.frg-crd-indx-clrs2 {
  border: 2px solid #3fbe7f;
  background: linear-gradient(
    90deg,
    rgba(220, 255, 237, 0.5) 0%,
    rgba(220, 255, 237, 0) 50.75%,
    rgba(220, 255, 237, 0.5) 101.5%
  );
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.frg-crd-indx-clrs3 {
  border: 2px solid #da5f9d;
  background: linear-gradient(
    90deg,
    rgba(255, 224, 240, 0.5) 0%,
    rgba(255, 224, 240, 0) 50.75%,
    rgba(255, 224, 240, 0.5) 101.5%
  );
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.frg-crd-indx-clrs4 {
  border: 2px solid #f69737;
  background: linear-gradient(
    90deg,
    rgba(254, 241, 229, 0.5),
    rgba(254, 241, 229, 0),
    rgba(254, 241, 229, 0.5)
  );
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.frg-crd-indx-clrs5 {
  border: 2px solid #9f72cc;
  background: linear-gradient(
    90deg,
    rgba(237, 220, 255, 0.5),
    rgba(237, 220, 255, 0),
    rgba(237, 220, 255, 0.5)
  );
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.forge-cards {
  width: 600px;
  display: flex;
  /* flex-direction: column; */
  gap: 1rem;
  padding: 30px;
  border-radius: 10px;
}

.inside_card {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 30px 30px 30px 80px;
}

.frg-crd-title {
  font-size: 27px;
  font-weight: 500;
  line-height: 35px;
  color: #000000;
}

.frg-cnt-para {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #515151;
}

/* Providing liquidity */

.prov-liqdty {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.prov-liqdty > h1 {
  color: #000000;
  font-size: 50px;
  font-weight: 700;
  text-align: center;
}
.prov-liqdty > p {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #515151;
}

.cards-liquidity {
  width: 360px;
  padding: 10px 20px;
  /* height: 200px; */
  flex-grow: 1;
}

.cards-liquidity-custom-height {
  height: 220px;
}

.cards-liquidity > h2 {
  color: #e84427;
  font-weight: 600;
  line-height: 30px;
  font-size: 28px;
  white-space: nowrap;
}
.cards-liquidity > p {
  font-size: 16px;
  font-weight: 400;
  color: #515151;
}

.swapping-mforge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: -moz-fit-content;
  height: fit-content;
  gap: 1rem;
}

.brdr-right {
  border-right: 1px dotted #7c7c7c;
}

.swapping-mforge > h1 {
  color: #000000;
  font-weight: 700;
  line-height: 80px;
  font-size: 50px;
  text-align: center;
}

.swapping-contnr {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  width: 97%;
  height: 100%;
}

.swapping-cards {
  width: 240px;
  /* height: 100%; */
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 0 10px 0 #0000004d;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
}

.swapping-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.swapping-cards > h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: 37px;
  white-space: nowrap;
  color: #000000;
}

.swapping-cards > p {
  color: #515151;
  font-size: 16px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
}

.swapping-cards .nums {
  font-weight: 600;
  font-size: 36px;
  bottom: 33px;
  line-height: 45px;
}

.wht-bdr {
  bottom: 15px;
  width: 100%;
  height: 15px;
  background-color: #fff;
}

@media screen and (max-width: 1295px) {
  .swap_main {
    justify-content: space-around;
    width: 100%;
  }

  .brdr-right {
    border: none;
  }

  .cards-liquidity {
    text-align: center;
  }
}

@media screen and (max-width: 1100px) {
  .frg_crd_cnt {
    left: 1rem;
  }

  .crd-cnt {
    left: -1.5rem;
  }

  .crd-nums {
    left: 36px;
  }
}

@media screen and (max-width: 720px) {
  .swap-exchng-comp {
    width: 100%;
  }
  .swap-left-guid {
    width: 90%;
  }
  .swap-exchng-comp img {
    width: 97%;
  }

  .frg_crd_cnt {
    width: 90%;
    height: auto;
  }
}
@media screen and (max-width: 600px) {
  .forge_card {
    width: 100%;
    justify-content: center;
  }

  .frg_crd_cnt {
    left: 0;
  }
  .inside_card {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px 30px 0 30px;
  }
  .swapping-cards > h2{
    font-size: 20px;
  }
  .swap-title {
    font-size: 32px;
  }

  .prov-liqdty > h1 {
    font-size: 32px;
  }

  .swapping-mforge > h1 {
    text-align: center;
    font-size: 32px;
    line-height: 45px;
  }
  .swapping-cards > p{
    font-size: 16px;
  }

  .frg-content-box {
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .cards-liquidity {
    width: 90%;
  }

  .cards-liquidity > h2 {
    white-space: wrap;
    font-size: 20px;
  }

  .forge-cards-main {
    row-gap: 5rem;
    margin: 0;
  }

  .crd-nums {
    left: auto;
    top: -67px;
  }

  .crd-cnt {
    top: -50px;
    left: auto;
    width: 100px;
    height: 100px;
  }

  .mforge_main {
    margin-bottom: 1rem;
  }

  .swap-btn-grp {
    justify-content: center;
  }
  .rspnswpBtn{
    width: 205px !important;
  }
  .frg-crd-title{
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Trade/Trade.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB;;;;;GAKC;EACD,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB;;;;;GAKC;EACD,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB;;;;;GAKC;EACD,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB;;;;;GAKC;EACD,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB;;;;;GAKC;EACD,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAmB;EAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".swap-btn-grp {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.swap-left-guid {\n  width: 600px;\n}\n\n.swap-title {\n  font-size: 50px;\n  font-weight: 700;\n  color: #000;\n  letter-spacing: 3px;\n}\n\n.swap_main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n}\n\n.swap-para-text {\n  color: #515151;\n  font-size: 17px;\n  font-weight: 400;\n}\n\n.swap-exchng-comp {\n  width: 650px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  height: fit-content;\n  padding: 1.5rem;\n}\n\n.forge-cards-main {\n  display: flex;\n  justify-content: space-around;\n  /* align-items: center; */\n  flex-wrap: wrap;\n  row-gap: 3rem;\n  column-gap: 5rem;\n  margin-left: 20px;\n}\n\n.forge_card {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.crd-cnt {\n  width: 120px;\n  height: 120px;\n  background-color: #0e4e8d;\n  color: #fff;\n  font-size: 42px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: 26px;\n  left: -45px;\n  /* margin: 0 auto; */\n}\n\n.crd-nums {\n  color: #fff;\n  font-size: 45px;\n  font-weight: 600;\n  /* position: absolute; */\n  left: 65px;\n  top: 48px;\n  z-index: 2;\n}\n\n.cdt-cnt1 {\n  background-color: #0e4e8d;\n}\n.cdt-cnt2 {\n  background-color: #3fbe7f;\n}\n.cdt-cnt3 {\n  background-color: #da5f9d;\n}\n.cdt-cnt4 {\n  background-color: #f69737;\n}\n.cdt-cnt5 {\n  background-color: #9f72cc;\n}\n\n.frg_crd_cnt {\n  /* position: relative; */\n  left: 3rem;\n  width: 495px;\n  height: 210px;\n  padding: 10px 12px;\n  border-radius: 10px;\n}\n\n.frg-crd-indx-clrs1 {\n  border: 2px solid #0e4e8d;\n  background: linear-gradient(\n    90deg,\n    rgba(228, 241, 255, 0.5) 0%,\n    rgba(228, 241, 255, 0) 50.75%,\n    rgba(228, 241, 255, 0.5) 101.5%\n  );\n  backdrop-filter: blur(10px);\n}\n.frg-crd-indx-clrs2 {\n  border: 2px solid #3fbe7f;\n  background: linear-gradient(\n    90deg,\n    rgba(220, 255, 237, 0.5) 0%,\n    rgba(220, 255, 237, 0) 50.75%,\n    rgba(220, 255, 237, 0.5) 101.5%\n  );\n  backdrop-filter: blur(10px);\n}\n.frg-crd-indx-clrs3 {\n  border: 2px solid #da5f9d;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 224, 240, 0.5) 0%,\n    rgba(255, 224, 240, 0) 50.75%,\n    rgba(255, 224, 240, 0.5) 101.5%\n  );\n  backdrop-filter: blur(10px);\n}\n\n.frg-crd-indx-clrs4 {\n  border: 2px solid #f69737;\n  background: linear-gradient(\n    90deg,\n    rgba(254, 241, 229, 0.5),\n    rgba(254, 241, 229, 0),\n    rgba(254, 241, 229, 0.5)\n  );\n  backdrop-filter: blur(10px);\n}\n.frg-crd-indx-clrs5 {\n  border: 2px solid #9f72cc;\n  background: linear-gradient(\n    90deg,\n    rgba(237, 220, 255, 0.5),\n    rgba(237, 220, 255, 0),\n    rgba(237, 220, 255, 0.5)\n  );\n  backdrop-filter: blur(10px);\n}\n\n.forge-cards {\n  width: 600px;\n  display: flex;\n  /* flex-direction: column; */\n  gap: 1rem;\n  padding: 30px;\n  border-radius: 10px;\n}\n\n.inside_card {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 30px 30px 30px 80px;\n}\n\n.frg-crd-title {\n  font-size: 27px;\n  font-weight: 500;\n  line-height: 35px;\n  color: #000000;\n}\n\n.frg-cnt-para {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 22px;\n  color: #515151;\n}\n\n/* Providing liquidity */\n\n.prov-liqdty {\n  width: 100%;\n  height: fit-content;\n  border-radius: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.prov-liqdty > h1 {\n  color: #000000;\n  font-size: 50px;\n  font-weight: 700;\n  text-align: center;\n}\n.prov-liqdty > p {\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n  color: #515151;\n}\n\n.cards-liquidity {\n  width: 360px;\n  padding: 10px 20px;\n  /* height: 200px; */\n  flex-grow: 1;\n}\n\n.cards-liquidity-custom-height {\n  height: 220px;\n}\n\n.cards-liquidity > h2 {\n  color: #e84427;\n  font-weight: 600;\n  line-height: 30px;\n  font-size: 28px;\n  white-space: nowrap;\n}\n.cards-liquidity > p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #515151;\n}\n\n.swapping-mforge {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: fit-content;\n  gap: 1rem;\n}\n\n.brdr-right {\n  border-right: 1px dotted #7c7c7c;\n}\n\n.swapping-mforge > h1 {\n  color: #000000;\n  font-weight: 700;\n  line-height: 80px;\n  font-size: 50px;\n  text-align: center;\n}\n\n.swapping-contnr {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n  width: 97%;\n  height: 100%;\n}\n\n.swapping-cards {\n  width: 240px;\n  /* height: 100%; */\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: 0 0 10px 0 #0000004d;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  gap: 1rem;\n  flex-grow: 1;\n}\n\n.swapping-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.swapping-cards > h2 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 37px;\n  white-space: nowrap;\n  color: #000000;\n}\n\n.swapping-cards > p {\n  color: #515151;\n  font-size: 16px;\n  line-height: 30px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.swapping-cards .nums {\n  font-weight: 600;\n  font-size: 36px;\n  bottom: 33px;\n  line-height: 45px;\n}\n\n.wht-bdr {\n  bottom: 15px;\n  width: 100%;\n  height: 15px;\n  background-color: #fff;\n}\n\n@media screen and (max-width: 1295px) {\n  .swap_main {\n    justify-content: space-around;\n    width: 100%;\n  }\n\n  .brdr-right {\n    border: none;\n  }\n\n  .cards-liquidity {\n    text-align: center;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .frg_crd_cnt {\n    left: 1rem;\n  }\n\n  .crd-cnt {\n    left: -1.5rem;\n  }\n\n  .crd-nums {\n    left: 36px;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .swap-exchng-comp {\n    width: 100%;\n  }\n  .swap-left-guid {\n    width: 90%;\n  }\n  .swap-exchng-comp img {\n    width: 97%;\n  }\n\n  .frg_crd_cnt {\n    width: 90%;\n    height: auto;\n  }\n}\n@media screen and (max-width: 600px) {\n  .forge_card {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .frg_crd_cnt {\n    left: 0;\n  }\n  .inside_card {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 50px 30px 0 30px;\n  }\n  .swapping-cards > h2{\n    font-size: 20px;\n  }\n  .swap-title {\n    font-size: 32px;\n  }\n\n  .prov-liqdty > h1 {\n    font-size: 32px;\n  }\n\n  .swapping-mforge > h1 {\n    text-align: center;\n    font-size: 32px;\n    line-height: 45px;\n  }\n  .swapping-cards > p{\n    font-size: 16px;\n  }\n\n  .frg-content-box {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .cards-liquidity {\n    width: 90%;\n  }\n\n  .cards-liquidity > h2 {\n    white-space: wrap;\n    font-size: 20px;\n  }\n\n  .forge-cards-main {\n    row-gap: 5rem;\n    margin: 0;\n  }\n\n  .crd-nums {\n    left: auto;\n    top: -67px;\n  }\n\n  .crd-cnt {\n    top: -50px;\n    left: auto;\n    width: 100px;\n    height: 100px;\n  }\n\n  .mforge_main {\n    margin-bottom: 1rem;\n  }\n\n  .swap-btn-grp {\n    justify-content: center;\n  }\n  .rspnswpBtn{\n    width: 205px !important;\n  }\n  .frg-crd-title{\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
